/* Adventskalender (sections/advent-calendar.liquid): Türchen öffnen, geöffnete merken, Erinnerung in der App.
   Inhalte schickt der Server erst ab ihrem Tag; hier wird nur gezeigt, was schon in der Seite steht.
   Immer nach deutscher Zeit. */
(() => {
  const fmt = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Berlin', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit' });
  const berlin = (ms = Date.now()) => {
    const p = {};
    fmt.formatToParts(new Date(ms)).forEach((x) => { p[x.type] = x.value; });
    return { y: +p.year, m: +p.month, d: +p.day, h: +p.hour % 24, ymd: Number(p.year + p.month + p.day) };
  };
  /* Berliner Ortszeit → Zeitstempel (Sommer-/Winterzeit wird berücksichtigt) */
  const at = (y, m, d, h) => {
    const guess = Date.UTC(y, m - 1, d, h);
    const p = berlin(guess);
    return guess - (Date.UTC(p.y, p.m - 1, p.d, p.h) - guess);
  };
  const isApp = () => document.documentElement.classList.contains('is-app');
  const plugins = () => (window.Capacitor && window.Capacitor.Plugins) || {};
  const haptic = (style) => { plugins().Haptics?.impact?.({ style }).catch(() => {}); };
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const store = {
    get(year) { try { return JSON.parse(localStorage.getItem(`lb_advent_${year}`) || '[]'); } catch (_) { return []; } },
    add(year, day) {
      const list = this.get(year);
      if (list.includes(day)) return;
      list.push(day);
      try { localStorage.setItem(`lb_advent_${year}`, JSON.stringify(list)); } catch (_) { /* Speicher blockiert */ }
    }
  };

  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  };

  /* Seite aus dem Zwischenspeicher von gestern? Dann den Abschnitt frisch holen (Schlüssel je Stunde). */
  const refresh = (sec) => {
    const today = Number(sec.dataset.today);
    const base = Number(sec.dataset.base);
    const now = berlin();
    if (window.Shopify && window.Shopify.designMode) return;
    if (now.ymd <= today || today >= base + 24 || now.ymd <= base) return;
    const key = `${now.ymd}${String(now.h).padStart(2, '0')}`;
    if (sec.dataset.refreshed === key) return;
    fetch(`${location.pathname}?section_id=${encodeURIComponent(sec.dataset.akalSection)}&akal=${key}`)
      .then((r) => (r.ok ? r.text() : Promise.reject()))
      .then((html) => {
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-akal]');
        if (!fresh || Number(fresh.dataset.today) <= today) return;
        const node = document.importNode(fresh, true);
        node.dataset.refreshed = key;
        sec.replaceWith(node);
        init(node.parentNode);
      })
      .catch(() => {});
  };

  const daysUntil = (year, day) => {
    const n = berlin();
    return Math.round((Date.UTC(year, 11, day) - Date.UTC(n.y, n.m - 1, n.d)) / 864e5);
  };

  const storeLinks = (sec) => {
    const wrap = el('p', 'akal__d-links');
    const add = (url, label) => {
      if (!url) return;
      const a = el('a', 'btn btn--signal', label);
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener';
      wrap.appendChild(a);
    };
    const ua = navigator.userAgent;
    if (!/Android/.test(ua)) add(sec.dataset.ios, 'App Store');
    if (!/iPhone|iPad|iPod/.test(ua)) add(sec.dataset.android, 'Google Play');
    return wrap.children.length ? wrap : null;
  };

  const show = (sec, nodes) => {
    const dlg = sec.querySelector('[data-akal-dialog]');
    const body = sec.querySelector('[data-akal-body]');
    body.replaceChildren(...nodes);
    body.querySelectorAll('[data-akal-copy]').forEach((b) => b.addEventListener('click', () => {
      navigator.clipboard?.writeText(b.dataset.akalCopy).then(() => { b.textContent = sec.dataset.copied; haptic('LIGHT'); }).catch(() => {});
    }));
    // Hintergrundbild: in der App direkt speichern, sobald die App das kann; sonst öffnet der Link das große Bild
    const save = plugins().AppBridge?.saveWallpaper;
    if (isApp() && save) {
      body.querySelectorAll('[data-akal-wall]').forEach((a) => a.addEventListener('click', (e) => {
        e.preventDefault();
        save({ url: a.dataset.akalWall }).then((r) => { if (r && r.saved) a.textContent = `${a.textContent.replace(/ ✓$/, '')} ✓`; }).catch(() => {});
      }));
    }
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
  };

  const message = (sec, door, text) => {
    const nodes = [el('p', 'scribble akal__d-day', door.getAttribute('aria-label')), el('p', 'akal__d-text', text)];
    if (door.dataset.hint) nodes.push(el('p', 'akal__d-small', door.dataset.hint));
    return nodes;
  };

  const open = (sec, door) => {
    const year = Number(sec.dataset.year);
    const day = Number(door.dataset.akalDay);
    if (door.dataset.state === 'locked') {
      door.classList.remove('is-shake');
      void door.offsetWidth;
      door.classList.add('is-shake');
      haptic('LIGHT');
      const left = daysUntil(year, day);
      const text = left <= 1 ? sec.dataset.soon : sec.dataset.locked.replace('{n}', left);
      show(sec, message(sec, door, text));
      return;
    }
    if ('onlyApp' in door.dataset && !isApp()) {
      const nodes = message(sec, door, sec.dataset.appOnly);
      const links = storeLinks(sec);
      if (links) nodes.push(links);
      show(sec, nodes);
      return;
    }
    const tpl = sec.querySelector(`[data-akal-content="${day}"]`);
    if (!tpl) return;
    const first = !door.classList.contains('is-opened');
    door.classList.add('is-opened', 'is-opening');
    store.add(year, day);
    if (first) haptic('MEDIUM');
    setTimeout(() => show(sec, [tpl.content.cloneNode(true)]), first && !reduced() ? 650 : 0);
  };

  /* Schnee oder Glitzer über dem Kalender (Einstellung „Über dem Kalender“) */
  const effects = (sec) => {
    const kind = sec.dataset.fx;
    sec.querySelector(':scope > .akal__fx')?.remove();
    if (!kind || reduced()) return;
    const layer = el('div', 'akal__fx');
    layer.setAttribute('aria-hidden', 'true');
    const count = Math.round((Number(sec.dataset.fxAmount) || 40) * (kind === 'snow' ? 0.9 : 0.5));
    const rnd = (a, b) => a + Math.random() * (b - a);
    layer.style.setProperty('--h', `${sec.offsetHeight}px`);
    for (let i = 0; i < count; i += 1) {
      const f = document.createElement('i');
      f.style.left = `${rnd(0, 100)}%`;
      if (kind === 'snow') {
        f.style.setProperty('--s', `${rnd(3, 7).toFixed(1)}px`);
        f.style.setProperty('--x', `${rnd(-40, 40).toFixed(0)}px`);
        f.style.setProperty('--t', `${rnd(9, 18).toFixed(1)}s`);
        f.style.setProperty('--d', `${rnd(-18, 0).toFixed(1)}s`);
      } else {
        f.style.setProperty('--s', `${rnd(8, 16).toFixed(0)}px`);
        f.style.setProperty('--y', `${rnd(2, 96).toFixed(0)}%`);
        f.style.setProperty('--t', `${rnd(2.4, 5).toFixed(1)}s`);
        f.style.setProperty('--d', `${rnd(-5, 0).toFixed(1)}s`);
      }
      layer.appendChild(f);
    }
    sec.prepend(layer);
  };

  /* Erinnerung jeden Morgen: das Handy plant die Mitteilungen selbst (AppBridge.reminders, neuere App-Versionen) */
  const remind = (sec) => {
    const btn = sec.querySelector('[data-akal-remind]');
    const bridge = plugins().AppBridge;
    if (!btn || !isApp() || !bridge || !bridge.reminders || !sec.dataset.remind) return;
    const label = btn.querySelector('span');
    const off = label.textContent;
    const set = (on) => {
      btn.setAttribute('aria-pressed', String(on));
      label.textContent = on ? sec.dataset.remindOn : off;
    };
    const year = Number(sec.dataset.year);
    const hour = Number(sec.dataset.remind);
    const items = () => {
      const list = [];
      for (let day = 1; day <= 24; day += 1) {
        const ms = at(year, 12, day, hour);
        if (ms > Date.now()) list.push({ at: ms, title: sec.dataset.remindTitle, text: sec.dataset.remindText.replace('{n}', day), path: location.pathname });
      }
      return list;
    };
    if (!items().length) return;
    btn.hidden = false;
    bridge.reminders({ id: 'advent', query: true }).then((r) => set(!!(r && r.count))).catch(() => {});
    btn.addEventListener('click', () => {
      const on = btn.getAttribute('aria-pressed') !== 'true';
      bridge.reminders({ id: 'advent', items: on ? items() : [] }).then((r) => {
        set(!!(r && r.count));
        if (on && r && r.count) haptic('MEDIUM');
      }).catch(() => {});
    });
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-akal]').forEach((sec) => {
      if (sec.dataset.akalReady) return;
      sec.dataset.akalReady = '1';
      const year = Number(sec.dataset.year);
      const opened = store.get(year);
      sec.querySelectorAll('[data-akal-day]').forEach((door) => {
        if (door.dataset.state !== 'locked' && opened.includes(Number(door.dataset.akalDay))) door.classList.add('is-opened');
        door.addEventListener('click', () => open(sec, door));
      });
      const dlg = sec.querySelector('[data-akal-dialog]');
      const close = () => { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); };
      sec.querySelector('[data-akal-close]').addEventListener('click', close);
      dlg.addEventListener('click', (e) => { if (e.target === dlg) close(); });
      dlg.addEventListener('close', () => {
        dlg.querySelectorAll('video').forEach((v) => v.pause());
        // „Wieder zu“: Türchen schließen sich nach dem Lesen
        sec.querySelectorAll('.is-opening').forEach((d) => d.classList.remove('is-opening'));
      });
      effects(sec);
      remind(sec);
      refresh(sec);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  // Zurück in die App nach Mitternacht: neuen Tag nachladen
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') document.querySelectorAll('[data-akal]').forEach(refresh);
  });
})();
